import { app } from '../../../../app';
import { Controller } from './login-role-select.controller';

app.component('loginRoleSelect', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./login-role-select.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/login-role-select/login-role-select.component.js